// extracted by mini-css-extract-plugin
export var search = "SearchInput-module--search--ab5e8";
export var searchinput = "SearchInput-module--searchinput--55453";
export var searchinputwrapper = "SearchInput-module--searchinputwrapper--64a1d";
export var searchtitle = "SearchInput-module--searchtitle--f8ef9";
export var searchtitlecontainer = "SearchInput-module--searchtitlecontainer--8cfe3";